import { useLocation } from "react-router-dom";

import { PAY_URL } from "appConstants";

export function PayRedirect() {
  const { search } = useLocation();
  window.location.replace(`${PAY_URL}${search}`);
  return null;
}
